import React, { useCallback, useMemo } from 'react';

import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import { IconButton, Menu, MenuItem } from '@mui/material';

import useStyles from './styles';

import { FormattedDataItem } from '../../types';

interface Props {
    data: FormattedDataItem;
    className?: string;
}

const RowMenu: React.FC<Props> = ({ data, className }) => {
    const { classes, cx } = useStyles();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const isOpen = Boolean(anchorEl);

    const handleMoreClick = useCallback((event) => setAnchorEl(event.currentTarget), []);
    const handleCloseMore = useCallback(() => setAnchorEl(null), []);
    const stopPropagation = useCallback((event: React.MouseEvent) => event.stopPropagation(), []);

    const hasLabels = useMemo(() => {
        const { references, exploits, affectedSoftware, affectedPackages, affectedConfiguration } = data;
        return [references, exploits, affectedSoftware, affectedPackages, affectedConfiguration].some(Boolean);
    }, [data]);

    if (!hasLabels) {
        return null;
    }

    return (
        <div className={cx(classes.root, className)} onClick={stopPropagation}>
            <IconButton className={classes.button} onClick={handleMoreClick}>
                {<MoreHorizOutlinedIcon />}
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={isOpen}
                onClose={handleCloseMore}
                MenuListProps={{ className: classes.menuList }}
            >
                {data.references ? (
                    <MenuItem className={classes.menuItem}>
                        {'References'}
                        <span className={classes._minor}>{data.references}</span>
                    </MenuItem>
                ) : null}
                {data.exploits ? (
                    <MenuItem className={classes.menuItem}>
                        {'Exploits'}
                        <span className={classes._minor}>{data.exploits}</span>
                    </MenuItem>
                ) : null}
                {data.affectedSoftware ? (
                    <MenuItem className={classes.menuItem}>
                        {'Affected Software'}
                        <span className={classes._minor}>{data.affectedSoftware}</span>
                    </MenuItem>
                ) : null}
                {data.affectedPackages ? (
                    <MenuItem className={classes.menuItem}>
                        {'Affected Packages'}
                        <span className={classes._minor}>{data.affectedPackages}</span>
                    </MenuItem>
                ) : null}
                {data.affectedConfiguration ? (
                    <MenuItem className={classes.menuItem}>
                        {'Affected Configuration'}
                        <span className={classes._minor}>{data.affectedConfiguration}</span>
                    </MenuItem>
                ) : null}
            </Menu>
        </div>
    );
};

export default RowMenu;
